import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import { InputAdornment } from '@material-ui/core';
import config from '../../config/config';

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));

export default function GoogleMapsGet(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);
  const [errorAPIHandler, setErrorAPIHandler] = React.useState();

  let address;
  let place_id;

  const handleKeyDown = e => {
		if (e.key === " " && e.target.selectionStart !==0) {
      var val = document.getElementById('google_suggestion_address');
      val.value = val.value.replace(/ +(?= )/g,'');
		}else if(e.key === " " && e.target.selectionStart ===0) {
		  e.preventDefault();
		}
	  };

  const handleLoad = () => {
    if (typeof window !== 'undefined' && !loaded.current) {
      if (!document.querySelector('#google-maps')) {
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places`,
          document.querySelector('head'),
          'google-maps',
        );
      }
      loaded.current = true;
    }
  }

  const fetch_map = React.useMemo(
    () =>
      throttle((request, callback) => {
        var inpValue = request.input
        var request = {
          input: inpValue,
          componentRestrictions: { country: 'us' },
        };
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    [],
  );

  React.useEffect(() => {
    props.setDisplayError(false)
    let active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();

    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch_map({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }
        if (results) {
          if (results !== null) {
            newOptions = [...newOptions, ...results];
          }
        }
        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch_map]);

  const handleGoogleResult = (value) => {
    address = value ? value.description : ''
    place_id = value ? value.place_id : ''

    fetch(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${place_id}&key=${process.env.REACT_APP_GOOGLE_MAP_KEY}`,
    )
      .then(async response => {
        const result = await response.json()
        if (response.status === 201 || response.status === 200) {
          if (result?.error_message) {
            setErrorAPIHandler(result)
          }
          let geo_value = result.results[0]
          props.values.property_address_get.street_address = address
            geo_value.address_components.map((value) => {
              if(geo_value.geometry.location_type !== 'APPROXIMATE') {
                if (value.types[0] === "postal_code") {
                  let postal_code = value.long_name
                  props.values.property_address_get.zip_code = postal_code;
                }
              }

              if (value.types[0] === "country") {
                let country = value.long_name
              }
              if (value.types[0] === "administrative_area_level_1") {
                let state = value.long_name
                let state_code = value.short_name
                props.values.property_address.state = state;
                props.values.property_address.state_code = state_code
              }
              if (value.types[0] === "locality") {
                let city = value.long_name
                props.values.property_address_get.city = city;
              } else if (value.types[1] === "sublocality") {
                let sub_city = value.long_name
                props.values.property_address_get.city = sub_city;
              }
              if (value.types[0] === "administrative_area_level_2") {
                let county = value.long_name
                props.values.property_address_get.county = county;
              }
              props.handleReset()
            })
          
        } else if (response.status === 403 || response.status === 400 || response.status === 500) {
          if (result?.error_message) {
            setErrorAPIHandler(result)
          }
          props.values.property_address_get.street_address = '';
          props.values.property_address_get.zip_code = null;
          props.values.property_address_get.state = '';
          props.values.property_address_get.city = '';
          props.values.property_address_get.county = '';
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    if ((errorAPIHandler && errorAPIHandler.error_message) && errorAPIHandler.error_message !== "Invalid request. Invalid 'place_id' parameter.") {
      var postUserQue = {
        app_name: props?.partner?.partner_name ? `customer_portal/${props?.partner?.partner_name}` : 'customer_portal',
        trace: errorAPIHandler && errorAPIHandler.error_message,
        api_url: "https://maps.googleapis.com/"
      }
      let authorise = process.env.REACT_APP_API_KEY;
      fetch(`${config.baseUrlCP}google-api-errors/`,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Authorization': `${authorise}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(postUserQue),
        })
        .then(async response => {
          const results = await response.json()
          if (response.status === 201 || response.status === 200) {
          }
          else {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    }
  }, [errorAPIHandler])
  useEffect(() => {
    let autocomplete = document.getElementsByClassName('googleMapApi_autocomplete')
    if (autocomplete[0]) {
      let clear = document.getElementsByClassName('MuiAutocomplete-clearIndicatorDirty')
      if (clear[0]) {
        clear[0].addEventListener('click', function (event) {
          props.values.property_address.street_address = '';
        })
      }
    }
  }, [])

  const handleError = (value) => {
    if (value) {
      props.errors.street_address = ''
    }
  }

  const [catchError, setCatchError] = useState(false)
  return (
    <div>
      <Autocomplete
        className="w-100 py-1 googleMapApi_autocomplete"
        name="property_address_get.street_address"
        freeSolo
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
        filterOptions={(x) => x}
        options={options}
        autoComplete
        // disabled={props.location ===true}
        disabled={
          props.location === true && !window.location.pathname.includes('questionnaire') ||
          (window.location.pathname.includes('questionnaire') && props.submitResponse !== null)
        }
        includeInputInList
        id="google_suggestion_address"
        filterSelectedOptions
        onKeyDown={handleKeyDown}
        value={props.values && props.values.property_address_get.street_address && props.values.property_address_get.street_address.trimStart()}
        onChange={props.handleChange, (event, newValue) => {
          setOptions(newValue ? [newValue, ...options] : options);
          setValue(newValue);
          handleGoogleResult(newValue);
          props.handleLocationGet?.();
        }}
        onInputChange={props.handleChange, (event, newInputValue) => {
          setInputValue(newInputValue);
          handleLoad();
          handleError(newInputValue);
        }}
        renderInput={(params) => (
          <TextField {...params} placeholder={props?.megastar?.url_path === 'megastar' ? 'Current primary address' : "Address"} margin="normal" variant="outlined"
            style={{ height: "52px", marginTop: '8px' }}
            fullWidth InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon />
                </InputAdornment>
              ),
            }} />
        )}
        renderOption={(option) => {
          try {
            const matches = option.structured_formatting.main_text_matched_substrings;
            const parts = parse(
              option.structured_formatting.main_text,
              matches.map((match) => [match.offset, match.offset + match.length]),
            );
            setCatchError(false);
            return (
              <Grid container alignItems="center">
                <Grid item>
                  <LocationOnIcon className={classes.icon} />
                </Grid>
                <Grid item xs>
                  {parts.map((part, index) => (
                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                      {part.text}
                    </span>
                  ))}
                  <Typography variant="body2" color="textSecondary">
                    {option.structured_formatting.secondary_text}
                  </Typography>
                </Grid>
              </Grid>
            );
          } catch (error) {
            setCatchError(true)
          }
        }}
      />
      {catchError &&
        <div className="error-msg">Address Entered is not valid, Please enter a valid USA address</div>
      }
      {(() => {
        if (catchError) {
          return <div className="error-msg">Address Entered is not valid, Please enter a valid USA address</div>;
        } else if (
            props.validateDisplay17 === "bannerID" && props.errors.street_address ||
            props.validateDisplay18 === "contentID" && props.errors.street_address ||
            (inputValue !== "" && props.values.property_address_get.zip_code === null && props.errors.street_address) ||
            (props.zipcodeEmptyErr === "This field may not be null." && props.submitValidationSuccess === true &&
            (inputValue === "" || props.values.property_address_get.street_address === "")) ||
            (props.zipcodeEmptyErr === "This field may not be null." && props.values.property_address_get.street_address === "" && inputValue !== "" && value === null && props.values.property_address_get.zip_code === null)
          ) {
          return <div className="error-msg">Please enter a valid property address</div>;
          }
          return null;
      })()}
    </div>
  );
}